import pt from './messages-pt.json';
import en from './messages-en.json';
import es from './messages-es.json';

/**
 * Indice dos arquivos de mensagens i18n
 * @author Fábio Sartori
 * @copyright 2019/06s
 */

export default {
    undefined: pt,
    'en-us': en,
    'pt-br': pt,
    'es-es': es
}